// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_c15329d","titleWrap":"_02adcdf","state":"_cb4e012","type":"_e35afd4","title":"_a2b4d95","buttonsWrap":"_893ab24","unregister":"_4b3e31b"};